import { Breadcrumb } from "@fluentui/react";
import { useLocation } from "react-router-dom";
import { LinkWithParams } from "utils/components/LinkWithParams";

export const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(x => x);

  const breadcrumbItems = [
    { text: "Home", key: "home", onClick: () => {}, href: "/" },
    ...pathnames.map((value, index) => {
      const to = `/${pathnames.slice(0, index + 1).join("/")}`;
      return {
        text: value.charAt(0).toUpperCase() + value.slice(1),
        key: to,
        onClick: () => {},
        href: to,
      };
    }),
  ];

  return (
    <Breadcrumb
      style={{ fontSize: "13px" }}
      /* Add padding around the chevron */
      styles={{ chevron: { padding: "0 4px" } }}
      items={breadcrumbItems.map(item => ({
        ...item,
        onRender: props => {
          /* Dont create a link for the last item */
          if (props && props.href && props.href !== location.pathname) {
            return (
              /* No underline on the link */
              <LinkWithParams
                role="link"
                style={{ textDecoration: "none" }}
                to={props.href}
                key={props.key}
              >
                {props.text}
              </LinkWithParams>
            );
          }
          return (
            <span key={props && props.key}>
              {(props && props.text) || "DEFAULT"}
            </span>
          );
        },
      }))}
      ariaLabel="Breadcrumb with static width"
    />
  );
};
